/* eslint-disable react/no-array-index-key */

import { generateIdByText } from '@lib/data/prismic/helpers';
import { smoothScrool } from '@lib/helpers/ui';
import { Elements, RichText } from 'prismic-reactjs';

export function TableOfContents({
  slice: {
    primary: { title1 },
  },
  sliceZone,
  heads,
}:
  | {
      sliceZone: any[];
      slice: {
        primary: { title1: string };
      };
      heads?: undefined;
    }
  | {
      heads: { text: string; id: string }[];
      sliceZone?: undefined;
      slice: {
        primary: { title1: string };
      };
    }) {
  const sliceTypesWithHeaders: Record<string, { field: string }> = {
    text: {
      field: 'text',
    },
    faq: {
      field: 'title',
    },
  };

  const slicesWithHeaders = sliceZone?.filter((slice) =>
    Object.keys(sliceTypesWithHeaders).includes(slice.slice_type),
  );

  const tocLinks =
    heads?.map(({ id, text }, index) => (
      <li key={`toc-link-${index}-${id}`}>
        <a
          onClick={(e) => {
            e.preventDefault();

            smoothScrool(id);
          }}
          href={`#${id}`}
        >
          {text}
        </a>
      </li>
    )) ||
    slicesWithHeaders
      ?.map((slice, index) => {
        const headerFieldKey = sliceTypesWithHeaders[slice.slice_type].field;

        const headerField: { type: Elements; text: string }[] | string =
          slice.primary[headerFieldKey] || [];

        if (typeof headerField === 'string') {
          const id = generateIdByText(headerField);
          return [
            <li key={`toc-link-${index}-${id}`}>
              <a
                onClick={(e) => {
                  e.preventDefault();

                  smoothScrool(id);
                }}
                href={`#${id}`}
              >
                {headerField}
              </a>
            </li>,
          ];
        }

        return headerField
          .map((block, blockIndex) => {
            if (block.text && block.type === 'heading2') {
              const id = generateIdByText(block.text);
              return (
                <li key={`toc-link-${index}-${blockIndex}`}>
                  <a
                    onClick={(e) => {
                      e.preventDefault();

                      smoothScrool(id);
                    }}
                    href={`#${id}`}
                  >
                    {RichText.asText([block])}
                  </a>
                </li>
              );
            }
            return null;
          })
          .filter((item) => item != null);
      })
      .filter((item) => item.length > 0);

  if (tocLinks?.length === 0) return null;

  return (
    <div>
      {title1 && <h3>{title1}</h3>}
      <ul>{tocLinks}</ul>
    </div>
  );
}
